import { render, staticRenderFns } from "./EditarSalaEspera.vue?vue&type=template&id=487785a4"
import script from "./EditarSalaEspera.vue?vue&type=script&lang=js"
export * from "./EditarSalaEspera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports